<template>
    <ui-modal
        :name="`${mode}-add-signers`"
        :data-ui-cancel-button="'button-close-modal-newSigner'"
        icon="-"
        size="sm"
    >
        <template #title>
            <div class="modal-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                    <path d="M16.6667 0H3.33333C1.49479 0 0 1.51348 0 3.375V23.625C0 25.4865 1.49479 27 3.33333 27H16.6667C18.5052 27 20 25.4865 20 23.625V3.375C20 1.51348 18.5052 0 16.6667 0ZM18.3333 23.625C18.3333 24.5531 17.5833 25.3125 16.6667 25.3125H3.33333C2.41667 25.3125 1.66667 24.5531 1.66667 23.625V3.375C1.66667 2.44688 2.41667 1.6875 3.33333 1.6875H16.6667C17.5833 1.6875 18.3333 2.44688 18.3333 3.375V23.625ZM7.5 5.0625H12.5C12.9583 5.0625 13.3333 4.68281 13.3333 4.21875C13.3333 3.75469 12.9583 3.375 12.5 3.375H7.5C7.04167 3.375 6.66667 3.75469 6.66667 4.21875C6.66667 4.68281 7.04167 5.0625 7.5 5.0625ZM10 16.0312C12.3021 16.0312 14.1667 14.1434 14.1667 11.8125C14.1667 9.48164 12.3021 7.59375 10 7.59375C7.69792 7.59375 5.83333 9.48164 5.83333 11.8125C5.83333 14.1434 7.69792 16.0312 10 16.0312ZM10 9.28125C11.3802 9.28125 12.5 10.415 12.5 11.8125C12.5 13.21 11.3802 14.3438 10 14.3438C8.61979 14.3438 7.5 13.21 7.5 11.8125C7.5 10.415 8.61979 9.28125 10 9.28125ZM12.4375 16.875C11.4219 16.875 11.1667 17.2441 10 17.2441C8.83333 17.2441 8.57812 16.875 7.5625 16.875C6.45833 16.875 5.38542 17.3707 4.76042 18.3199C4.38542 18.8842 4.16667 19.5645 4.16667 20.2975V22.3594C4.16667 22.5914 4.35417 22.7812 4.58333 22.7812H5.41667C5.64583 22.7812 5.83333 22.5914 5.83333 22.3594V20.2975C5.83333 19.5592 6.30208 18.5625 7.5625 18.5625C8.20833 18.5625 8.64583 18.9316 10 18.9316C11.349 18.9316 11.7865 18.5625 12.4375 18.5625C13.7031 18.5625 14.1667 19.5592 14.1667 20.2975V22.3594C14.1667 22.5914 14.3542 22.7812 14.5833 22.7812H15.4167C15.6458 22.7812 15.8333 22.5914 15.8333 22.3594V20.2975C15.8333 19.5645 15.6146 18.8842 15.2396 18.3199C14.6094 17.3707 13.5365 16.875 12.4375 16.875Z" fill="#1E84E9"/>
                </svg>

                <span class="title">Adicionar Assinante</span>
            </div>
        </template>

        <template>
            <div class="content-body">
                <div class="name">
                    <ui-input
                        v-model="form.data.name"
                        :required="form.fields.name.required"
                        :error="!!errors['name']"
                        :observation="errors['name']"
                        :data-ui="'input-name-modal-newSigner'"
                        label="Nome:"
                        placeholder="Digite..."
                        size="lg"
                    />
                </div>

                <div v-if="hasDocumentation" class="cpf-birth-date">
                    <div class="cpf">
                        <ui-input
                            v-model="form.data.cpf"
                            v-cpf
                            :required="form.fields.cpf.required"
                            :error="!!errors['cpf']"
                            :observation="errors['cpf']"
                            :data-ui="'input-cpf-modal-newSigner'"
                            mask="###.###.###-##"
                            label="CPF:"
                            placeholder="Digite..."
                            size="lg"
                        />
                    </div>

                    <div class="birth-date">
                        <ui-datepicker
                            v-model="form.data.birthday"
                            :required="form.fields.birthday.required"
                            :min-date="false"
                            :error="!!errors['birthday']"
                            :observation="errors['birthday']"
                            :data-ui-input="'input-date-birthday-modal-newSignature'"
                            :data-ui-button="'button-calendar-modal-newSignature'"
                            label="Data de Nascimento:"
                            placeholder="Digite..."
                            size="lg"
                        />
                    </div>
                </div>

                <div class="cell-email">
                    <ui-input
                        v-model="form.data.whatsapp_number"
                        :required="form.fields.whatsapp_number.required"
                        :error="!!errors['whatsapp_number']"
                        :observation="errors['whatsapp_number']"
                        :data-ui="'input-mobile-modal-newSigner'"
                        type="tel"
                        mask="(##) #####-####"
                        label="Celular:"
                        placeholder="Digite..."
                        size="lg"
                    />

                    <ui-input
                        v-model="form.data.email"
                        :required="form.fields.email.required"
                        :error="!!errors['email']"
                        :observation="errors['email']"
                        :data-ui="'input-email-modal-newSigner'"
                        type="email"
                        label="E-mail:"
                        placeholder="Digite..."
                        size="lg"
                    />
                </div>

                <div class="paper-maker">
                    <ui-select-v2
                        v-model="form.data.role"
                        :required="form.fields.role.required"
                        :data="roleOptions"
                        :error="!!errors['role']"
                        :observation="errors['role']"
                        :data-ui-selected="'select-paper-modal-newSigner'"
                        :data-ui-search="'search-select-paper-newSigner'"
                        :data-ui-options="'list-select-paper-newSigner'"
                        :data-ui-cancel-button="'button-cancel-select-newSigner'"
                        return-value="value"
                        label="Papel:"
                        size="lg"
                        @input="roleHandler"
                    />

                    <ui-input
                        v-if="mode === 'docu_sign'"
                        v-model="formattedKeyword"
                        :required="form.fields.keyword.required"
                        :error="!!errors['keyword']"
                        :observation="errors['keyword']"
                        label="Marcador:"
                        placeholder="Digite..."
                        size="lg"
                    />

                    <ui-select-v2
                        v-if="mode === 'click_sign'"
                        v-model="form.data.auth"
                        :data="authOptions"
                        :required="form.fields.auth.required"
                        :error="!!errors['auth']"
                        :observation="errors['auth']"
                        return-value="value"
                        label="Prova de Identidade:"
                        size="lg"
                    />
                </div>

                <div class="can-refuse-document">
                    <ui-switch
                        v-if="mode === 'click_sign'"
                        v-model="form.data.refusable"
                        :checked="form.data.refusable"
                        :error="!!errors['refusable']"
                        :observation="errors['refusable']"
                        design="sm"
                        label="Pode recusar a assinatura do documento"
                    />
                </div>

                <div class="can-refuse-document">
                    <ui-switch
                        v-if="mode === 'click_sign'"
                        v-model="form.data.communicate_events.signature_request"
                        :checked="form.data?.communicate_events?.signature_request === 'whatsapp'"
                        value-true="whatsapp"
                        value-false="email"
                        :error="!!errors['signature_request']"
                        :observation="errors['signature_request']"
                        design="sm"
                        label="Receber o contrato via WhatsApp"
                    />
                </div>
            </div>
        </template>

        <template #footer>
            <span class="cancel" data-ui="button-cancel-modal-newSigner" @click="cancel">
                Cancelar
            </span>

            <ui-button
                :disabled="!!Object.keys(errors).length"
                :data-ui="'button-add-modal-new-signer'"
                design="primary md mw-100"
                @click="save"
            >
                {{ editing ? 'Salvar' : 'Adicionar' }}
            </ui-button>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
    
	import {
        uiInput,
        uiDatepicker,
        uiSelectV2,
        uiSwitch
    } from '@/components/ui/form'

    import { cpf } from "@/directives"
    import { utilMixin, helpersMixin } from '@/mixins'
    import { $mx_generateSignerKeyword } from '@/mixins/helpers'


    const lodash = require("lodash")
    import { mapActions, mapGetters } from 'vuex'

    import {
        docuRoles,
        clickRoles,
        onlineRoles,
        auths
    } from '@/assets/js/data'

    const defaultData = () => ({
        type: 'nonuser',
        name: '',
        cpf: '',
        birthday: null,
        whatsapp_number: '',
        email: '',
        role: '',
        keyword: {
            name: ''
        },
        auth: '',
        refusable: false,
		communicate_events: { signature_request: 'email' },
        has_documentation: false,
        selected: true
    })

	export default {
		name: 'ui-add-signers-modal',

		components: {
			uiModal,
			uiButton,
            uiInput,
            uiDatepicker,
            uiSelectV2,
            uiSwitch
		},

        directives: { cpf },

        mixins: [utilMixin, helpersMixin],

        props: {
            /**
             * Define que tipo de integração irá utilizar o assinante
             */
            mode: {
                type: String,
                required: false,
                default: 'docu_sign'
            },
            /**
             * Define se os campos de CPF e Data de Nascimento serão mostrados e
             * obrigatórios
             */
            hasDocumentation: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        data() {
            return {
                form: {
                    data: { ...defaultData() },
                    fields: {
                        name: {
                            required: true
                        },
                        cpf: {
                            required: true
                        },
                        birthday: {
                            required: true
                        },
                        whatsapp_number: {
                            required: true
                        },
                        email: {
                            required: true
                        },
                        role: {
                            required: true
                        },
                        keyword: {
                            required: false
                        },
                        auth: {
                            required: false
                        },
                        refusable: {
                            required: false
                        },
						signature_request: {
							required: false
						}
                    }
                },
                authOptions: [...auths],
                loading: false,
                errors: {},
                editing: false
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                signers: 'getSigners'
            }),
            /**
             * Computed property que retorna as opções do select de papel, de acordo
             * com o tipo de integração
             */
            roleOptions() {
                let options = []
                switch (this.mode) {
                    case 'docu_sign':
                        options = [...docuRoles]
                        break

                    case 'click_sign':
                        options = [...clickRoles]
                        break

                    case 'assine_online':
                        options = [...onlineRoles]
                        break
                }

                return options
            },
            /**
             * Adiciona as barras '/' no início e no final do valor digitado no marcador
             */
            formattedKeyword: {
              get() {
                return this.form.data.keyword.name
              },
              set(value) {
                let isRemovingChar = value.length < this.form.data.keyword.name.length
                            
                // Se a remoção não for uma barra no final, então remove o último caractere
                if (isRemovingChar && value.charAt(value.length - 1) !== '/') {
                  value = value.slice(0, -1)
                }

                if(value == '/') {
                    this.form.data.keyword.name = ''
                    return
                }
                
                this.form.data.keyword.name = `/${value.replace(/[\/\\]/g, '')}/`
                }
            },
        },

        watch: {
            /**
             * Observa por mudanças nos campos obrigatórios para validação
             */
            'form.data': {
                deep: true,
                handler() {
                    // Busca quais campos devem ser validados
                    const required = Object.keys(this.form.fields).filter(field => {
                        return field !== 'has_documentation' && this.form.fields[field].required
                    })
                    const defaultForm = { ...defaultData() }
                    // Copia apenas os campos requeridos para validação
                    const oldValues = required.reduce((a, field) => (
                        a[field] = defaultForm[field],
                        a
                    ), {})
                    const newValues = required.reduce((a, field) => (
                        a[field] = this.form.data[field],
                        a
                    ), {})

                    // Verifica se houveram alterações nos campos observados
                    if (!this.$mx_isChangedDeeper(newValues, oldValues)) {
                        this.errors = { ...this.validateForm()?.errors }

                    } else {
                        this.errors = {}
                    }
                }
            }
        },

        created() {
            this.$root.$on(`modal-open-${this.mode}-add-signers`, (payload) => {
                if (payload) {
                    this.editing = true
                    this.form.data = { ...payload }
                }
                this.form.fields.keyword.required = false
                this.form.fields.auth.required = false
                this.form.fields.cpf.required = this.hasDocumentation
                this.form.fields.birthday.required = this.hasDocumentation
                this.form.data.has_documentation = this.hasDocumentation

                switch (this.mode) {
                    case 'docu_sign':
                        this.form.fields.keyword.required = true
                        break

                    case 'click_sign':
                        this.form.fields.auth.required = true
                        break

                    case 'assine_online':
                        break
                }
            })
        },

        methods: {
            ...mapActions('digitalSignatureStore', ['setSigners']),
            /**
             * Event handler que trata o evento de quando um papel é selecionado para
             * o assinante
             */
            roleHandler(value) {
                this.form.data.label = this.roleOptions.find(option => option.value === value)?.label
            },

            keywordRoleHandle(){
                if (!this.form.data.keyword.name || !this.form.data.role) return
                
                this.form.data.keyword = $mx_generateSignerKeyword(this.form.data.keyword.name, this.form.data.role)
            },
            /**
			 * Valida a propriedade required dos campos do formulário
			 */
			validateRequired(field, dataField = '') {
				if (!Object.prototype.hasOwnProperty.call(this.form.fields, field)) {
					throw new Error(`Falha ao validar o campo ${field}. Este campo não existe!`)
				}

				dataField = dataField || field
				const required = this.form.fields[field].required
				const validation = lodash.get(this.form.data, dataField) ||
					parseInt(lodash.get(this.form.data, dataField)) === 0

				return (required && validation) || !required
			},
			/**
			 * Valida os campos do formulário de acordo com diferentes conjuntos de regras
			 */
			validateForm() {
				let valid = true
				let errors = {}

				try {
					if (!this.validateRequired('name')) {
						valid = false
						errors['name'] = 'É necessário informar o nome do assinante.'
					}

					if (!this.validateRequired('cpf')) {
						valid = false
						errors['cpf'] = 'É necessário informar o CPF do assinante.'
					}

					if (!this.validateRequired('birthday')) {
						valid = false
						errors['birthday'] = 'É necessário informar a data de nascimento do assinante.'
					}

					if (!this.validateRequired('whatsapp_number')) {
						valid = false
						errors['whatsapp_number'] = 'É necessário informar o número de celular do assinante.'
					}

					if (!this.validateRequired('email')) {
						valid = false
						errors['email'] = 'É necessário informar o e-mail do assinante.'
					}

					if (!this.validateRequired('role')) {
						valid = false
						errors['role'] = 'É necessário informar o papel do assinante.'
					}

					if (!this.validateRequired('keyword', 'keyword.name')) {
						valid = false
						errors['keyword'] = 'É necessário informar o marcador do assinante.'
					}

                    if (!this.validateRequired('auth')) {
						valid = false
						errors['auth'] = 'É necessário informar a prova de identidade do assinante.'
					}

				} catch (e) {
					this.$toastr.e(e)
					valid = false
				}

				return { valid, errors }
			},
            /**
             * Salva a nova configuração de assinante
             */
            save() {
                if (!this.validateForm()?.valid) {
                    this.errors = { ...this.validateForm()?.errors }
                    return
                }

                let signers = [...this.signers]
                this.keywordRoleHandle()

                // Verifica se é uma edição dos assinantes
                if (this.editing) {
                    const index = signers.findIndex(signer => {
                        return signer._uid === this.form.data._uid
                    })
                    if (index < 0) {
                        this.$toastr.e('Assinante não encontrado!')
                        return
                    }
                    signers[index] = { ...this.form.data }
                } else {
                    signers.push({ ...this.form.data })
                }
                this.setSigners(signers)

                this.form.data = { ...defaultData() }
                this.editing = false
                this.errors = {}
                this.$root.$emit(`modal-close-${this.mode}-add-signers`)
            },
            /**
             * Cancela o cadastro de um novo assinante e limpa o formulário
             */
            cancel() {
                this.form.data = { ...defaultData() }
                this.$root.$emit(`modal-close-${this.mode}-add-signers`)
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>